import { Spin } from 'antd'
import React from 'react'
import styles from './LazyLoadCommon.module.scss';

export default function LayzyLoadCommon() {
  return (
    <div className={styles.lazyload_common}>
      <Spin spinning={true} size="large" ></Spin>
    </div>
  )
}
